import { Component, Input, OnInit } from '@angular/core';
import { ProductCard, ProductsService } from 'src/app/products.service';

@Component({
  selector: 'app-components-eol',
  templateUrl: './components-eol.component.html',
  styleUrl: './components-eol.component.scss'
})
export class ComponentsEolComponent implements OnInit {

  constructor(
    public _productsService: ProductsService,){}
  @Input() title: string = '';
  @Input() eol: string = '';
  @Input() lastbuy: string = '';
  @Input() lastship: string = '';
  @Input("data") replacements: any[];
  replacelist = [];
    ngOnInit() {
      if(this.lastbuy == '' || this.lastship == ''){
      const eoldate = new Date(this.eol);
      const daysAfter = (date: Date, days: number): Date => {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
      };
        if(this.lastbuy == ''){
          this.lastbuy = daysAfter(eoldate, 30).toISOString().split('T')[0];
        }
        if(this.lastship == ''){
          this.lastship = daysAfter(eoldate, 90).toISOString().split('T')[0];
        }
      }
  
      // Use the Map to efficiently find matching products
      if(this.replacements){
      // Create a Map for O(1) lookup time
      const productMap = new Map(
        this._productsService.productcards.map(card => [card.title, card])
      );
      this.replacelist = this.replacements
        .map(title => productMap.get(title))
        .filter((card): card is ProductCard => card !== undefined);

        console.log(`Replacements for ${this.title}:`, this.replacelist);
      }
        
    }

}
